<template>
	<BContainer class="h-100">
		<BRow align-h="center" align-v="center"
			class="h-100">
			<BCol lg="8">
				<div class="d-flex justify-content-center mb-4">
					<logo :width="64" />
				</div>
				<BCard>
					<template v-if="already_paid">
						<div class="row">
							<div class="col">
								<div>
									<h3>Error</h3>
									<p>Looks like this link is invalid or the fee has already been paid.</p>
								</div>
							</div>
						</div>
					</template>
					<template v-else>
						<div
							v-if="success"
							class="row">
							<div class="col">
								<h3>Thank you</h3>
								<div class="d-flex align-items-center gap-xs">
									<lottie-player src="/assets/animations/success.json"
										autoplay
										style="width: 25px; height: auto;">
									</lottie-player>
									<p class="mb-0">
										We've received your payment! A confirmation has also been sent to your email address.
									</p>
								</div>
							</div>
						</div>
						<div
							v-if="!success"
							class="row">
							<div class="col-md-12">
								<h1>
									Registration Fee
								</h1>
								<table class="table">
									<thead>
										<tr>
											<th>Fee</th>
											<th>Amount</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>
												{{ registration_fee.title }}
											</td>
											<td>
												${{ registration_fee.amount }}
											</td>
										</tr>
										<tr>
											<td>
												Processing Fees
											</td>
											<td>
												$0.00
											</td>
										</tr>
									</tbody>
									<tfoot>
										<tr>
											<td>
												Total
											</td>
											<td>
												${{ getTotal() }}
											</td>
										</tr>
									</tfoot>
								</table>
								<h3>How would you like to pay the registration fee?</h3>
								<div class="my-4"></div>
								<BFormRadioGroup :model-value="paymentMethod" buttons
									button-variant="white" class="d-flex flex-1"
									@update:model-value="paymentMethod = $event">
									<BFormRadio value="upfront" class="flex-1 d-flex flex-column justify-content-center">
										<div></div>
										<strong>Upfront Payment</strong>
										<div>One time of ${{ parseFloat(registration_fee.amount).toFixed(2) }}</div>
									</BFormRadio>
								</BFormRadioGroup>
								<hr>
								<credit-card-form
									ref="creditCardForm"
									:country="country" />
								<div class="row m-2">
									<div class="col">
										<div
											v-if="payment_errors.length"
											class="alert alert-danger mb-0">
											<p
												v-for="(error, index) in payment_errors"
												:key="index"
												class="mb-0">
												{{ error }}
											</p>
										</div>
									</div>
								</div>
								<div v-if="getValidationErrors('general')" class="row m-2">
									<div class="col">
										<div
											class="alert alert-danger mb-0">
											<p
												class="mb-0">
												{{ getValidationErrors('general') }}
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</template>
					<template v-if="!success && !already_paid" #footer>
						<BButton
							variant="primary" block
							:disabled="loading || !paymentMethod"
							class="d-flex align-items-center gap-sm"
							@click="pay">
							<BSpinner v-if="loading" small></BSpinner>
							Pay
						</BButton>
					</template>
				</BCard>
			</BCol>
		</BRow>
	</BContainer>
</template>

<script>
	import { useValidation } from '@js/composables/useValidation.js';
	import Logo from '@js/components/my/ui/Logo.vue';
	import CreditCardForm from '@js/components/my/client/CreditCardForm.vue';

	export default {
		name: 'RegistrationFeeCheckout',
		components: {
			Logo,
			CreditCardForm,
		},
		props: {
			uuid: {
				type: String,
				required: true
			}
		},
		setup() {
			return {
				...useValidation(),
			};
		},
		data() {
			return {
				already_paid: false,
				country: null,
				registration_fee: {},
				complete: false,
				success: false,
				loading: false,
				total: 0,
				payment_errors: [],
				paymentMethod: 'upfront',
			}
		},
		mounted() {
			this.fetchFee();
		},
		methods: {
			getTotal() {
				let registration_fee = this.registration_fee;
				return parseFloat(registration_fee.amount).toFixed(2)
			},
			fetchFee() {
				this.$axios.get(`/api/registration-fees/${this.uuid}`).then(response => {
					this.registration_fee = response.data;
					this.country = this.registration_fee.currency == 'NZD' ? 'NZ' : 'AU';
				}).catch(() => {
					this.already_paid = true;
				})
			},
			async pay() {
				this.loading = true;
				this.payment_errors = [];

				const token = await this.$refs.creditCardForm.createToken().catch(error => {
					this.payment_errors = error;
				});

				await this.$axios.post(`/api/registration-fees/${this.uuid}`, {
					stripe_token: token,
					payment_method: this.paymentMethod
				}).then(() => {
					this.success = true;
					this.loading = false;
				}).catch(error => {
					this.payment_errors = error.response.data.errors;
					this.handleError(error);
					this.loading = false;
				});
			},
		}
	}
</script>
<style scoped>
	.stripe-card {
		width: 300px;
		padding-left: 1rem;
	}

	.stripe-card.complete {
		border-color: green;
	}

	.card {
		border: none;
	}
</style>
